import React from 'react'
import './styles/Dash.css'

const Dash = () => {
  return <div className='dash'></div>
}

export default Dash
